// user notes
export const GET_USER_NOTES_REQUEST = 'GET_USER_NOTES_REQUEST';
export const GET_USER_NOTES_SUCCESS = 'GET_USER_NOTES_SUCCESS';
export const GET_USER_NOTES_FAILURE = 'GET_USER_NOTES_FAILURE';
export const CLEAR_USER_NOTES = 'CLEAR_USER_NOTES';

// public notes
export const GET_PUBLIC_NOTES_REQUEST = 'GET_PUBLIC_NOTES_REQUEST';
export const GET_PUBLIC_NOTES_SUCCESS = 'GET_PUBLIC_NOTES_SUCCESS';
export const GET_PUBLIC_NOTES_FAILURE = 'GET_PUBLIC_NOTES_FAILURE';
export const CLEAR_PUBLIC_NOTES = 'CLEAR_PUBLIC_NOTES';

// single note
export const GET_NOTE_REQUEST = 'GET_NOTE_REQUEST';
export const GET_NOTE_SUCCESS = 'GET_NOTE_SUCCESS';
export const GET_NOTE_FAILURE = 'GET_NOTE_FAILURE';
export const CLEAR_NOTE = 'CLEAR_NOTE';

// selection
export const SELECT_NOTE = 'SELECT_NOTE';
export const CLEAR_SELECTED_NOTE = 'CLEAR_SELECTED_NOTE';

// user notes pagination
export const SET_USER_NOTES_SEARCH = 'SET_USER_NOTES_SEARCH';
export const SET_USER_NOTES_PAGE_SIZE = 'SET_USER_NOTES_PAGE_SIZE';
export const NEXT_USER_NOTES_PAGE = 'NEXT_USER_NOTES_PAGE';
export const PREV_USER_NOTES_PAGE = 'PREV_USER_NOTES_PAGE';

// public notes pagination
export const SET_PUBLIC_NOTES_SEARCH = 'SET_PUBLIC_NOTES_SEARCH';
export const SET_PUBLIC_NOTES_PAGE_SIZE = 'SET_PUBLIC_NOTES_PAGE_SIZE';
export const NEXT_PUBLIC_NOTES_PAGE = 'NEXT_PUBLIC_NOTES_PAGE';
export const PREV_PUBLIC_NOTES_PAGE = 'PREV_PUBLIC_NOTES_PAGE';
